import React, { Component, useEffect } from 'react';
import { StyleSheet, View, Text } from 'react-native';

import { getMethod, postData } from '../../networking/api';


export default function DownloadSchedule({ }) {

    useEffect(() => {
        downloadDocument();
    }, [])

    const downloadDocument = async () => {
        try {
            const downloadDocumentResponse = await getMethod(
                "masters/downloadProgram/1"
            );
            var code = downloadDocumentResponse.code;
            if (code == 1) {
            } else {
            }
        } catch (error) {
            console.error("Error", error);
        }
    }


    return (
        <View style={styles.MainContainer}>

        </View>
    );
}


const styles = StyleSheet.create({
    MainContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        flex: 1,
        padding: 20,
    },
    mapStyle: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
});  